import { render, staticRenderFns } from "./Textos.vue?vue&type=template&id=2ab6278c&scoped=true&"
import script from "./Textos.vue?vue&type=script&lang=js&"
export * from "./Textos.vue?vue&type=script&lang=js&"
import style0 from "./Textos.vue?vue&type=style&index=0&id=2ab6278c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab6278c",
  null
  
)

export default component.exports